var _rect, _rect2, _rect3, _rect4, _rect5, _line, _path, _g, _rect6, _rect7, _mask, _rect8, _mask2, _rect9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureWorkPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 10,
    height: 10,
    rx: 2.5,
    stroke: "#2C3549"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 10,
    height: 10,
    rx: 2.5,
    stroke: "#2C3549"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 52.5,
    width: 9,
    height: 9,
    rx: 2,
    stroke: "#06ADEF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 52,
    width: 10,
    height: 10,
    rx: 2.5,
    stroke: "#2C3549"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 52,
    width: 10,
    height: 10,
    rx: 2.5,
    stroke: "#2C3549"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 24.5,
    x2: 46.5,
    y2: 24.5,
    stroke: "#2C3549",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 61.7308V67.5C69.5 70.2614 67.2614 72.5 64.5 72.5H8.5C5.73858 72.5 3.5 70.2614 3.5 67.5V17.5C3.5 14.7386 5.73858 12.5 8.5 12.5H64.5C67.2614 12.5 69.5 14.7386 69.5 17.5V19.6795",
    stroke: "#2C3549",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1867_5364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1666 40.729L62.5416 45.104L69.8333 36.354",
    stroke: "#06ADEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 54.5832C72.0541 54.5832 78.5833 48.054 78.5833 39.9998C78.5833 31.9457 72.0541 25.4165 64 25.4165C55.9458 25.4165 49.4166 31.9457 49.4166 39.9998C49.4166 48.054 55.9458 54.5832 64 54.5832Z",
    stroke: "#06ADEF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#2C3549"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 59.7002,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#2C3549"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 17.7002,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#2C3549"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_1867_5364",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 7,
    width: 10,
    height: 12,
    rx: 2
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 7,
    width: 10,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "#2C3549",
    strokeWidth: 6,
    mask: "url(#path-13-inside-1_1867_5364)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_1867_5364",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 7,
    width: 10,
    height: 12,
    rx: 2
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 7,
    width: 10,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "#2C3549",
    strokeWidth: 6,
    mask: "url(#path-14-inside-2_1867_5364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1867_5364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(46.5 22.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureWorkPlan);
export default __webpack_public_path__ + "static/media/feature-work-plan.82d0ac7a.svg";
export { ForwardRef as ReactComponent };